$("#filter-button, .filter-close").click(function() {
    $(".filter-sidebar").toggleClass("show-sidebar");
});
